export default function updateSignup() {
  const useTitle = true;
  const useDescription = true;
  const signupTitle = 'Stay Connected!';
  const signupTdescription = 'Sign up for news & updates from Dakota County Fair';
  const inputPlaceholder = 'Enter Email...';
  const buttonLabel = 'Subscribe';

  const $signupElement = $('.tier-4-container .signup-module .emailSignup');
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
      <div class="signup-text">
        ${useTitle ? `<h2 class="signup-title">${signupTitle}</h2>` : ''}
        ${useDescription ? `<p class="signup-description">${signupTdescription}</p>` : ''}
      </div>
    `);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
}
